import { ZoneTypeEnum } from '@/types/config/config.types';

export enum ZoneActiveStatusEnum {
  ACTIVATED = 'ACTIVATED',
  DISABLED = 'DISABLED',
}

export type ZoneManagementFiltersType = {
  type: ZoneTypeEnum | null;
  activeStatus: Set<ZoneActiveStatusEnum>;
};

export const DEFAULT_ZONE_FILTERS = { type: null, activeStatus: new Set(Object.values(ZoneActiveStatusEnum)) };
